export default __webpack_public_path__ + "static/techinsights_bg-261738b00a61fa7e6e50ebfd572311f5.png";